<template>
  <q-dialog
    class="ipa-dialog"
    v-model="opened"
    persistent
    :maximized="true"
    transition-show="slide-up"
    transition-hide="slide-down"
  >
    <q-card class="bg-primary text-white">
      <q-bar class="q-px-md q-py-lg">
        Iris Rule Builder
        <q-space />
        <q-btn dense flat icon="close" v-close-popup />
      </q-bar>

      <q-card-section>
        <rule-builder :data.prop="getData()" ref="builder" />
      </q-card-section>

      <div class="q-mt-lg q-mb-xl row justify-center">
        <q-btn
          class="q-px-xl q-py-sm"
          @click="buildRule"
          color="white"
          text-color="primary"
          icon="settings"
          label="Build Rule"
        />
      </div>
    </q-card>
  </q-dialog>
</template>

<script lang="ts">
import ApiService from '@/service'
import { defineComponent, ref } from 'vue'
import { mapState } from 'vuex'

export default defineComponent({
  setup() {
    return {
      opened: ref(false),
    }
  },
  methods: {
    buildRule() {
      const { $q } = this as any
      $q.loading.show({
        spinner: $q.QSpinnerGears,
      })
      ;(this.$refs.builder as any)
        .getVueInstance()
        .getConverterInput()
        .then((converterInput: any) => {
          ApiService.convertJSONtoPython(converterInput)
            .then((res: any) => {
              this.$emit('built', res.rule)
            })
            .catch(() => {
              this.$q.notify({
                message: 'Unfortunately, there was an error. Please retry or contact the team.',
                icon: 'error',
                color: 'red',
                position: 'top',
              })
            })
            .then(() => {
              this.$q.loading.hide()
            })
        })
        .catch(() => {
          this.$q.loading.hide()
        })
    },
    getData(this: any): object {
      return new Promise(resolve =>
        resolve({
          inputs: this.inputs,
          helpers: this.helpers,
        })
      )
    },
    open(this: any) {
      this.opened = true
    },
    close(this: any) {
      this.opened = false
    },
  },
  computed: {
    ...mapState({
      helpers: (state: any) => state?.scriptKey?.helpers,
      inputs: (state: any) => state?.scriptKey?.inputs,
    }),
  },
})
</script>

<style lang="scss">
.ipa-rule-builder {
  color: #333 !important;
  padding: 30px 80px;
  border-radius: 6px;

  .rule-blocks .rule-blocks-container:before {
    width: 121px !important;
  }

  .rule-block {
    box-sizing: content-box !important;
  }

  .skip {
    border-top: 0;
  }

  h1,
  .main-actions {
    display: none;
  }

  h4 {
    font-weight: bold;
    line-height: inherit;
  }
}

.el-popper {
  z-index: 10000 !important;
}
</style>
